import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef, useState} from 'react'
import {UUID} from 'yougile-util'
import {BoardView} from '@components/statistics/by-time/board-view'
import {
  ByTimeContext,
  ByTimeStore,
  useByTimeStore
} from '@components/statistics/by-time/by-time-store'
import {ChatUtils} from '@extensions/chat-utils'

export const ByTime = () => {
  const [byTimeStore] = useState(() => new ByTimeStore())

  return (
    <ByTimeContext.Provider value={byTimeStore}>
      <ByTimeBase />
    </ByTimeContext.Provider>
  )
}

const ByTimeBase = observer(() => {
  const [, store] = useByTimeStore()
  const chatChangeListener = useRef<UUID>()

  useEffect(() => {
    if (!chatChangeListener.current) {
      chatChangeListener.current = ChatUtils.addChatChangeListener(
        store.setOpenedTaskId
      )
    }

    return () => {
      if (chatChangeListener.current) {
        ChatUtils.removeChatChangeListener(chatChangeListener.current)
        chatChangeListener.current = undefined
      }
    }
  }, [])

  return <BoardView />
})
